module.exports = __webpack_public_path__ + "static/media/co2-icon.ac960ca6.png";